import { __assign, __extends, __rest } from "tslib";
import * as React from "react";
import cx from "classnames";
import "./Input.css";
var Input = (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
            value: _this.props.defaultValue
        };
        _this.handleFocus = function (e) {
            var onFocus = _this.props.onFocus;
            _this.setState({ focused: true });
            if (onFocus) {
                onFocus(e);
            }
        };
        _this.handleBlur = function (e) {
            var onBlur = _this.props.onBlur;
            _this.setState({ focused: false });
            if (onBlur) {
                onBlur(e);
            }
        };
        _this.handleChange = function (e) {
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(e);
            }
            else {
                _this.setState({ value: e.target.value });
            }
        };
        return _this;
    }
    Input.prototype.getInputNode = function () {
        return this.input;
    };
    Input.prototype.getValue = function () {
        return this.input ? this.getInputNode().value : undefined;
    };
    Input.prototype.blur = function () {
        if (this.input) {
            this.getInputNode().blur();
        }
    };
    Input.prototype.focus = function () {
        if (this.input) {
            this.getInputNode().focus();
        }
    };
    Input.prototype.select = function () {
        if (this.input) {
            this.getInputNode().select();
        }
    };
    Object.defineProperty(Input.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Input.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, dark = _a.dark, type = _a.type, className = _a.className, children = _a.children, label = _a.label, icon = _a.icon, invalid = _a.invalid, fullWidth = _a.fullWidth, inputProps = _a.inputProps, disabled = _a.disabled, id = _a.id, name = _a.name, onKeyPress = _a.onKeyPress, inputStyle = _a.inputStyle, wrapperStyle = _a.wrapperStyle, defaultValue = _a.defaultValue, rest = __rest(_a, ["value", "dark", "type", "className", "children", "label", "icon", "invalid", "fullWidth", "inputProps", "disabled", "id", "name", "onKeyPress", "inputStyle", "wrapperStyle", "defaultValue"]);
        var textValue = value !== undefined ? value : this.state.value;
        var wrapperClass = cx("Input", "Input__wrapper", {
            "Input__wrapper--dark": dark,
            "Input__wrapper--with-placeholder": label,
            "Input__wrapper--full-width": fullWidth
        });
        var inputClass = cx("Input__field", className, {
            "Input__field--icon": icon !== undefined,
            "Input__field--invalid": invalid
        });
        var placeholderIsUp = (textValue && textValue.length) || this.state.focused;
        var placeholderClass = cx("Input__placeholder", {
            "Input__placeholder--label": placeholderIsUp,
            "Input__placeholder--icon": icon !== undefined,
            "Input__placeholder--dark": dark,
            "Input__placeholder--invalid": invalid
        });
        return (React.createElement("div", { className: wrapperClass, style: wrapperStyle },
            icon && React.createElement("div", { className: "Input__icon" }, icon),
            label && (React.createElement("label", { htmlFor: id, className: placeholderClass }, label)),
            React.createElement("input", __assign({}, rest, inputProps, { ref: function (c) { return (_this.input = c); }, className: inputClass, type: type, onChange: this.handleChange, value: textValue, disabled: disabled, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeyPress: onKeyPress, name: name, id: id, style: inputStyle }), children)));
    };
    Input.defaultProps = {
        type: "text"
    };
    return Input;
}(React.Component));
export { Input };
export default Input;
